import { render, staticRenderFns } from "./DetailsOrder.vue?vue&type=template&id=2d99c5ec&scoped=true&"
import script from "./DetailsOrder.vue?vue&type=script&lang=js&"
export * from "./DetailsOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOrder.vue?vue&type=style&index=0&id=2d99c5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99c5ec",
  null
  
)

export default component.exports